import { FaLaravel } from "react-icons/fa6";
import { IoLogoFirebase } from "react-icons/io5";
import {
	SiAmazonwebservices,
	SiAngular,
	SiApollographql,
	SiDart,
	SiDocker,
	SiExpress,
	SiFastapi,
	SiFlutter,
	SiGit,
	SiGithub,
	SiGo,
	SiGooglecloud,
	SiGraphql,
	SiJavascript,
	SiKotlin,
	SiKubernetes,
	SiMongodb,
	SiMysql,
	SiNestjs,
	SiNextdotjs,
	SiNodedotjs,
	SiNuxtdotjs,
	SiPhp,
	SiPostgresql,
	SiPrisma,
	SiPython,
	SiReact,
	SiRedis,
	SiRedux,
	SiRust,
	SiSupabase,
	SiSvelte,
	SiSwift,
	SiTailwindcss,
	SiTypescript,
	SiVuedotjs,
} from "react-icons/si";

export const SKILL_ICON_MAP = {
	SiJavascript,
	SiTypescript,
	SiNodedotjs,
	SiPython,
	SiGo,
	SiPhp,
	SiRust,
	SiReact,
	SiNextdotjs,
	SiVuedotjs,
	SiNuxtdotjs,
	SiSvelte,
	SiAngular,
	SiTailwindcss,
	SiRedux,
	SiExpress,
	SiNestjs,
	SiFastapi,
	SiGraphql,
	SiApollographql,
	SiPrisma,
	SiSupabase,
	IoLogoFirebase,
	SiGooglecloud,
	SiAmazonwebservices,
	SiKubernetes,
	SiDocker,
	SiGit,
	SiGithub,
	SiMongodb,
	SiRedis,
	SiPostgresql,
	FaLaravel,
	SiMysql,
	SiFlutter,
	SiDart,
	SiKotlin,
	SiSwift,
} as const;

export type SkillIconKey = keyof typeof SKILL_ICON_MAP;
